import { DefaultConfigFile } from "./elisyan";
import { DefaultSopherConfigFile } from "./sopher";
import { DefaultSopherAccountingConfigFile } from "./sopher-accounting";
import { DefaultOlympeConfigFile } from "./olympe";
import { DefaultAurumConfigFile } from "./aurum";
import { DefaultAdamBenedictConfigFile } from "./adam-benedict";

export const themes = {
  elisyan: DefaultConfigFile,
  sopher: DefaultSopherConfigFile,
  sopheraccounting: DefaultSopherAccountingConfigFile,
  olympe: DefaultOlympeConfigFile,
  aurum: DefaultAurumConfigFile,
  adambenedict: DefaultAdamBenedictConfigFile,
};
